<template>
<div style="display: flex;justify-content: center">
  <input class="form-check-input" type="checkbox" :id="id" :checked="val" v-model="val">
  <label v-if="msg" class="form-check-label" :for="id">
    {{ msg }}
  </label>
</div>
</template>
<script>
export default
{
  props:{
    msg:{
      type:String,
      default: null
    },
    value:{
      type:Boolean,
      default:false
    },
  },
  watch:{
    val:function () {
      if(this.value != this.val) {
        this.$emit('input', this.val)
        this.$emit('change')
      }
    },
    value:function () {
      if(!this.value)
        this.val = false
      else
        this.val = true
    }
  },
  data: () => ({
    id:null,
    val:false,
  }),
  created() {
    var generateUUID = function() { // Public Domain/MIT
      var d = new Date().getTime();//Timestamp
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
      return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    this.id = 'chk'+generateUUID()
  },
  mounted() {
    if(!this.value)
      this.val = false
    else
      this.val = true
  }
}
</script>